'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import type { Address } from 'viem';
import { useMemo } from 'react';
import { getReadOnlyVault } from '../../helpers';
export interface UseReadOnlyVaultReturnType {
  message: string | undefined;
  isReadOnly: boolean;
}
export interface UseReadOnlyVaultProps {
  chainId: ChainId | null | undefined;
  address: Address | null;
}

/**
 * Returns the read-only vault message and whether the vault is read-only.
 *
 * @param options - The options for the read-only vault.
 * @param options.chainId - The chain ID of the vault.
 * @param options.address - The address of the vault.
 * @returns The read-only vault message and whether the vault is read-only.
 */
export const useReadOnlyVault = t0 => {
  const $ = _c(4);
  const {
    chainId,
    address
  } = t0;
  let t1;
  bb0: {
    if (!chainId || !address) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          message: undefined,
          isReadOnly: false
        };
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[1] !== address || $[2] !== chainId) {
      t2 = getReadOnlyVault({
        chainId,
        address
      });
      $[1] = address;
      $[2] = chainId;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = t2;
  }
  return t1;
};